import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { MenuDeleteService } from '../../services';

export const fetchMenuDelete = createAsyncThunk(
    'menuDelete/fetchMenuDelete',
    async ({ id }) => {
        const response = await MenuDeleteService(id)
        return response.result
    }
)

const menuDeleteSlice = createSlice({
    name: 'menuDelete',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMenuDelete.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchMenuDelete.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchMenuDelete.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default menuDeleteSlice.reducer;
